module.exports = __webpack_public_path__ + "media/images/lb/574-6f0c23bddeb7a521805b070e5dae2cfc.svg";